(function(){
  'use strict';
  if(window.location.pathname.indexOf('/policies/contact-information')===-1)return;
  var SV=(document.documentElement.lang||'').toLowerCase().indexOf('sv')===0;
  var HTML="<p><strong>CONTACTGEGEVENS</strong></p>\n<p>AUVENNE wordt geëxploiteerd door Griffioen Retail, een in Nederland geregistreerde onderneming.</p>\n<p>Bedrijfsnaam: Griffioen Retail<br>Handelsnaam: AUVENNE<br>E-mail: hallo@auvenne.com<br>Kamer van Koophandel (KvK): 99006367<br>Btw-nummer: NL005365840B30</p>\n<p>Voor vragen over bestellingen, producten, retouren of klachten kun je contact opnemen via hallo@auvenne.com.</p>\n<p>We streven ernaar binnen twee werkdagen te reageren.</p>";
  var TITLE="Contactgegevens";
  if(SV){
    HTML="<p><strong>KONTAKTUPPGIFTER</strong></p>\n<p>AUVENNE drivs av Griffioen Retail, ett företag registrerat i Nederländerna.</p>\n<p>Företagsnamn: Griffioen Retail<br>Handelsnamn: AUVENNE<br>E-post: hallo@auvenne.com<br>Nederländska handelskammaren (KvK): 99006367<br>Momsregistreringsnummer: NL005365840B30</p>\n<p>Har du frågor om beställningar, produkter, returer eller klagomål kan du kontakta oss via hallo@auvenne.com.</p>\n<p>Vi strävar efter att svara inom två arbetsdagar.</p>";
    TITLE="Kontaktuppgifter";
  }
  function apply(){
    var body=document.querySelector('.shopify-policy__body');
    if(!body)return false;
    if(body.dataset.auvPolicyNl!=='contact-information'){body.innerHTML=HTML;body.dataset.auvPolicyNl='contact-information';}
    var title=document.querySelector('.shopify-policy__title h1,.shopify-policy__title');
    if(title&&title.textContent.trim()!=TITLE)title.textContent=TITLE;
    document.documentElement.lang=SV?'sv':'nl';
    return true;
  }
  function start(){
    if(apply())return;
    var observer=new MutationObserver(function(){if(apply())observer.disconnect();});
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();